export default "__VITE_ASSET__D9vM7cuM__"